import React from 'react'
import SkillBox from '../feature/SkillBox/SkillBox'

const SkillBoxPage = () => {
  return (
   <SkillBox/>
  )
}

export default SkillBoxPage
